import * as factories from './factories';
import * as schema from './validation';
import * as transforms from './transforms';

export const ContactModel = {
  ...factories,
  ...schema,
  ...transforms,
};
